import { ComponentsPropsList } from '@mui/material';
import { Theme } from '@mui/material';

import { Settings } from '../../context/SettingsContext';

export type OwnerStateThemeType = {
  theme: Theme;
  ownerState: ComponentsPropsList[keyof ComponentsPropsList] &
    Record<string, unknown>;
};

// ** Overrides Imports
import { createThemeOverrideAccordion } from './accordion';
import { createThemeOverrideAlert } from './alerts';
import { createThemeOverrideAutocomplete } from './autocomplete';
import { createThemeOverrideAvatar } from './avatars';
import { createThemeOverrideBackdrop } from './backdrop';
import { createThemeOverrideBreadcrumbs } from './breadcrumbs';
import { createThemeOverrideButton } from './button';
import { createThemeOverrideButtonGroup } from './button-group';
import { createThemeOverrideCard } from './card';
import { createThemeOverrideChip } from './chip';
import { createThemeOverrideDataGrid } from './data-grid';
import { createThemeOverrideDialog } from './dialog';
import { createThemeOverrideDivider } from './divider';
import { createThemeOverrideFab } from './fab';
import { createThemeOverrideInput } from './input';
import { createThemeOverrideLink } from './link';
import { createThemeOverrideList } from './list';
import { createThemeOverrideMenu } from './menu';
import { createThemeOverridePagination } from './pagination';
import { createThemeOverridePaper } from './paper';
import { createThemeOverridePopover } from './popover';
import { createThemeOverrideProgress } from './progress';
import { createThemeOverrideRating } from './rating';
import { createThemeOverrideSelect } from './select';
import { createThemeOverrideSnackbar } from './snackbar';
import { createThemeOverrideSwitch } from './switches';
import { createThemeOverrideTable } from './table';
import { createThemeOverrideTabs } from './tabs';
import { createThemeOverrideTimeline } from './timeline';
import { createThemeOverrideToggleButtonGroup } from './toggle-button';
import { createThemeOverrideTooltip } from './tooltip';
import { createThemeOverrideTypography } from './typography';

export const createThemeOverrideComponentStyles = (settings: Settings) => {
  const { skin, mode } = settings;

  return Object.assign(
    createThemeOverrideAccordion(mode, skin),
    createThemeOverrideAlert(mode, skin),
    createThemeOverrideAutocomplete(mode, skin),
    createThemeOverrideAvatar(mode, skin),
    createThemeOverrideBackdrop(mode, skin),
    createThemeOverrideBreadcrumbs(mode, skin),
    createThemeOverrideButton(mode, skin),
    createThemeOverrideButtonGroup(mode, skin),
    createThemeOverrideCard(mode, skin),
    createThemeOverrideChip(mode, skin),
    createThemeOverrideDataGrid(mode, skin),
    createThemeOverrideDialog(mode, skin),
    createThemeOverrideDivider(mode, skin),
    createThemeOverrideFab(mode, skin),
    createThemeOverrideInput(mode, skin),
    createThemeOverrideLink(mode, skin),
    createThemeOverrideList(mode, skin),
    createThemeOverrideMenu(mode, skin),
    createThemeOverridePagination(mode, skin),
    createThemeOverridePaper(mode, skin),
    createThemeOverridePopover(mode, skin),
    createThemeOverrideProgress(mode, skin),
    createThemeOverrideRating(mode, skin),
    createThemeOverrideSelect(mode, skin),
    createThemeOverrideSnackbar(mode, skin),
    createThemeOverrideSwitch(mode, skin),
    createThemeOverrideTable(mode, skin),
    createThemeOverrideTabs(mode, skin),
    createThemeOverrideTimeline(mode, skin),
    createThemeOverrideToggleButtonGroup(mode, skin),
    createThemeOverrideTooltip(mode, skin),
    createThemeOverrideTypography(mode, skin)
  );
};

export default createThemeOverrideComponentStyles;
